import React from 'react';

import Header from '../header';
import Footer from '../footer';

import { GlobalStyle } from './styles';

export default ({ children, location }) => {
  return (
    <div className="app-wrapper">
      <GlobalStyle />
      <Header location={location} />
      {children}
      <Footer />
    </div>
  )
}
